module.exports = __webpack_public_path__ + "img/65.bb1bfc10.png";